import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';
import { push } from 'redux-router';

import { Motion, spring } from 'react-motion';

import connect from '../../utils/connect';

import { fetchSingleEditorial, clearSingleEditorial } from '../../actions/editorials';

import EditorialHeader from '../../components/editorial/header/header';
import EditorialContent from '../../components/editorial/content/content';

import ContextualMenu from '../../components/contextual/contextual';

import metaDesc from '../../utils/meta';

// import css from './editorial.scss';

class EditorialPage extends Component {

	constructor(props) {
		super(props);

		this.mounted = true;

		this.state = {
			transitioning: true,
			initialLoad: true,
		};
	}

	componentWillMount() {
		this.fetchSingle = bindActionCreators(fetchSingleEditorial, this.props.dispatch);

		let preview = false;
		if (this.props.router.location && this.props.router.location.query && this.props.router.location.query.preview) {
			preview = this.props.router.location.query.preview;
		}

		if (
			this.props.routeParams.slug &&
			(this.props.routeParams.slug !== this.props.editorials.single.slug || this.state.initialLoad)
		) {
			if (!this.state.transitioning) {
				this.setState({
					transitioning: true,
				});
			}

			this.fetchSingle(this.props.routeParams.slug, this.loadSuccess.bind(this), this.loadFail.bind(this), preview);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.routeParams.slug !== this.props.routeParams.slug) {
			if (!this.state.transitioning) {
				this.setState({
					transitioning: true,
				});
			}

			this.fetchSingle(nextProps.routeParams.slug, this.loadSuccess.bind(this), this.loadFail.bind(this));
		}
	}

	loadSuccess() {
		this.mounted && this.setState({
			initialLoad: false,
		});
	}

	loadFail() {
		this.props.dispatch(push('/error'));
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.editorials.single.id !== this.props.editorials.single.id ||
			nextProps.routeParams.slug !== this.props.routeParams.slug ||
			nextState !== this.state
		);
	}

	componentWillUnmount() {
		this.mounted = false;
		this.props.dispatch(clearSingleEditorial());
	}

	render() {
		if (!this.state.initialLoad) {
			const { browser } = this.props;
			const editorial = this.props.editorials.single;

			if (editorial.meta && editorial.meta.description !== this.metaDesc) {
				metaDesc(editorial.meta.description);
				this.metaDesc = editorial.meta.description;
			}

			let transitionClass = 'page__transition';

			if (this.state.transitioning && editorial.image) {
				transitionClass += ' page__transition--transitioning';
			}

			return (
				<article className='cf margin-bottom-contextual'>
					<Helmet title={`The FWA - ${this.getTitle()}`} />

					<div className={transitionClass}>
						<EditorialHeader editorial={editorial} browser={browser} onLoad={() => this.onHeaderImageLoaded()} />
						<EditorialContent editorial={editorial} browser={browser} />
					</div>

					<ContextualMenu dateFilter={editorial.types.contextDate} typeSlug={editorial.types.slug} next={editorial.next} prev={editorial.prev} thisId={editorial.id} intro={editorial.types.contextIntro} typeId={editorial.typeId} editorial type={editorial.types.contextType} name={editorial.types.name} />
				</article>
			);
		}

		return (
			<div>
				<Helmet title={`The FWA - ${this.getTitle()}`} />
				{this.renderWaiting()}
			</div>
		);
	}

	onHeaderImageLoaded() {
		if (this.state.initialLoad || this.state.transitioning) {
			this.setState({
				initialLoad: false,
				transitioning: false,
			});
		}
	}

	getTransitionStyle(ips) {
		const { opacity, top } = ips;
		// console.log(this.state.transitioning, opacity, top);

		return {
			position: 'relative',
			opacity,
			top: `${top}px`,
		};
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}

	getTitle() {
		if (this.props.editorials && this.props.editorials.single && this.props.editorials.single.title) {
			return this.props.editorials.single.title;
		}

		return 'Editorial';
	}
}

export default connect(EditorialPage);



/** WEBPACK FOOTER **
 ** ./frontend/containers/editorial/editorial.js
 **/